import { Directive } from '@angular/core';
import { FlexDirective as FlexLayoutFlexDirective } from '@angular/flex-layout';

const inputs = [
  'flLayoutFlex',
  'flLayoutFlex.mobile',
  'flLayoutFlex.tablet',
  'flLayoutFlex.desktop-small',
  'flLayoutFlex.desktop-large',
  'flLayoutFlex.desktop-xlarge',
  'flLayoutFlex.desktop-xxlarge',
];

@Directive({
  selector: `
    [flLayoutFlex],
    [flLayoutFlex.mobile],
    [flLayoutFlex.tablet],
    [flLayoutFlex.desktop-small],
    [flLayoutFlex.desktop-large],
    [flLayoutFlex.desktop-xlarge],
    [flLayoutFlex.desktop-xxlarge],
  `,
  inputs,
})
export class FlexDirective extends FlexLayoutFlexDirective {
  protected inputs = inputs;
}
